<template>
  <div
    v-click-outside="closeSelector"
    class="header-market-selector"
    :class="{ 'header-market-selector--is-open': isMarketSelectorOpen }">
    <oie-base-action
      v-if="mq('small')"
      class="header-market-selector__button"
      @click="toggleValue ({ key: 'isMarketSelectorOpen'})">
      {{ currentMarket.text + ' / ' + currentLanguage }}

      <template #iconPrepend>
        <oie-base-image
          :images="`/globalassets/languages/country_${clientModel.currentLanguage}.webp`"
          alt-text=""
          image-width="15px"
          image-height="15px">
        </oie-base-image>
      </template>
    </oie-base-action>
    <div
      v-if="isMarketSelectorOpen"
      class="header-market-selector__content">
      <oie-the-market-selector
        :markets="availableMarkets"
        :referrer-url="referrerUrl">
      </oie-the-market-selector>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    availableMarkets: {
      type: Array,
      required: true
    },
    referrerUrl: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters('ui', ['isMarketSelectorOpen']),
    currentMarket() {
      return this.availableMarkets.find(m => m.selected)
    },
    currentLanguage() {
      return this.clientModel.currentLanguage
    }
  },
  methods: {
    ...mapActions('ui', ['toggleValue']),
    closeSelector() {
      if (this.isMarketSelectorOpen) {
        this.toggleValue({ key: 'isMarketSelectorOpen', value: false })
      }
    }
  }
}
</script>

<style lang="scss">
.header-market-selector {
  @include body-semi-bold;
  position: relative;
  color: color(text-inverted);
  margin-right: measure(double);
}

.header-market-selector__button {
  @include reset-button;
}

.header-market-selector--is-open {
  z-index: 14;
}

.header-market-selector__content {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: measure(quarter);
  background-color: color(brand-blue-2);
  overflow: hidden;
  z-index: 2;

  @include media(small) {
    left: initial;
    right: 0;
  }
}
</style>
